import {IProduct} from "../models/IProduct.ts";
import {ISale} from "../models/ISale.ts";

export const getProductEffectivePrice = (product: IProduct, sales: ISale[] | undefined) => {
    const now = new Date();
    const clearTime = (date: Date) => {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return d;
    };
    const nowDay = clearTime(now);

    if (!sales) return product.price;

    for (const sale of sales) {
        const saleStartDay = clearTime(new Date(sale.from));
        const saleEndDay = clearTime(new Date(sale.to));

        const saleIsActive = saleStartDay <= nowDay && saleEndDay >= nowDay;

        if (saleIsActive && sale.items.find((item) => item === product._id)) {
            return product.price * (1 - sale.discount);
        }
    }

    return product.price;
};
